import { CircularProgress, Box, Typography } from "@mui/material";

const PreLoader = ({ message = "Loading, please wait..." }) => {
    return (
        <Box
            sx={{

                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                color: "blue", // gold/yellow theme
                marginTop: 10
            }}
        >
            <CircularProgress
                size={30}
                thickness={3}
                sx={{
                    color: "blue",
                    mb: 2,
                }}
            />
        </Box>
    );
};

export default PreLoader;
